import React, {ReactElement} from 'react';

import URLS from '../../../urls';
import SubNav from './SubNav';

type Props = {
  active: 'about' | 'supplier';
};

const entries = [
  {id: 'about', url: URLS.about.index, text: 'About Envirocrops'},
  {id: 'supplier', url: URLS.about.becomeSupplier, text: 'Become a supplier'},
];

const AboutNavigation = ({active}: Props): ReactElement => {
  return <SubNav entries={entries} active={active} />;
};

export default AboutNavigation;
